import differenceInHours from 'date-fns/differenceInHours'
import { isAppointmentBookingLocked } from 'Data/format.js'

export function isEditable(note, appointment) {
  return (
    differenceInHours(new Date(), Date.parse(note.sys_created)) <= 24 ||
    !isAppointmentBookingLocked(appointment)
  )
}
